import React, { useState } from 'react';
import '../styles/Shop.css';

const OgIcon = ({ size = 16 }) => (
  <img src="/assets/images/1.png" alt="og" className="og-icon" style={{ width: size, height: size, verticalAlign: 'middle' }} />
);

const DiscordSVG = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/>
  </svg>
);

const OnlinePaySVG = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="2" y1="10" x2="22" y2="10"></line>
  </svg>
);

const PACKS = [
  { id: 1, img: '/assets/Shop/og1.png', name: "Sachet d'Ogrines", amount: 30000, bonusAmount: 9000, price: 5 },
  { id: 2, img: '/assets/Shop/og2.png', name: "Bourse d'Ogrines", amount: 60000, bonusAmount: 23000, price: 10 },
  { id: 3, img: '/assets/Shop/og3.png', name: "Cassette d'Ogrines", amount: 120000, bonusAmount: 46000, price: 20 },
  { id: 4, img: '/assets/Shop/og4.png', name: "Coffre d'Ogrines", amount: 300000, bonusAmount: 90000, price: 50 },
  { id: 5, img: '/assets/Shop/og5.png', name: "Trésor d'Ogrines", amount: 600000, bonusAmount: 240000, price: 100, featured: true },
  
  { id: 6, img: '/assets/Items/id27.png', name: "Extra Pack", amount: 900000, bonusAmount: 400000, price: 150 },
  { id: 7, img: '/assets/Items/id27.png', name: "Mega Pack", amount: 1200000, bonusAmount: 550000, price: 200 },
  { id: 8, img: '/assets/Items/id27.png', name: "Pack Légendaire", amount: 1800000, bonusAmount: 900000, price: 300 }
];

const PAYMENT_METHODS = [
  { icon: '💳', name: 'Paysafecard', type: 'discord', label: 'Discord', url: 'https://discord.gg/dTuaMqvSAr' },
  { icon: '🎁', name: 'Carte cadeau', type: 'discord', label: 'Discord', url: 'https://discord.gg/dTuaMqvSAr' },
  { icon: '🅿️', name: 'PayPal ami', type: 'discord', label: 'Discord', url: 'https://discord.gg/dTuaMqvSAr' },
  { icon: '💳', name: 'Carte bancaire', type: 'forgestore', label: 'En ligne' },
  { icon: '🅿️', name: 'PayPal', type: 'forgestore', label: 'En ligne' },
];

const Shop = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleBuyClick = (type, url) => {
    if (type === 'discord') {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    if (type === 'forgestore') {
      setShowPopup(true);
    }
  };

  const confirmForgeStore = () => {
    setShowPopup(false);
    window.open('https://nexus-temporel.forgestore.net', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="shop-page">
      {/* --- POP-UP FORGESTORE --- */}
      {showPopup && (
        <div className="shop-popup-overlay">
          <div className="shop-popup-content">
            <h3>⚠️ Information Importante</h3>
            <p>
              Pour recevoir vos Ogrines en jeu, veuillez <strong>impérativement</strong> renseigner votre <strong style={{ color: '#B67A3C' }}>Nom de compte</strong> (et non le nom de votre personnage) dans le champ <em>"Utilisateur"</em> sur la page de paiement.
            </p>
            <div className="shop-popup-actions">
              <button className="shop-popup-cancel" onClick={() => setShowPopup(false)}>
                Annuler
              </button>
              <button className="shop-popup-confirm" onClick={confirmForgeStore}>
                J'ai compris, continuer <OnlinePaySVG />
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="shop-header">
        <h1>Boutique</h1>
        <p>Rechargez vos Ogrines et progressez dans l'aventure Nexus</p>
      </div>

      <div className="shop-grid">
        {PACKS.map((pack) => (
          <div key={pack.id} className={`pack-card${pack.featured ? ' featured' : ''}`}>
            {/* Le badge bonus principal a été retiré ici */}
            <img src={pack.img} alt={pack.name} className="pack-img" />
            <div className="pack-name">{pack.name}</div>
            <div className="pack-amount">
              {pack.amount.toLocaleString('fr-FR')} <OgIcon size={20} />
              {/* Le bonus en ligne a été retiré ici */}
            </div>
            <div className="pack-price-badge">{pack.price.toFixed(2).replace('.', ',')} €</div>

            <div className="pack-payments">
              {PAYMENT_METHODS.map((m, i) => {
                const onlineTotal = pack.amount + pack.bonusAmount;
                
                const isDiscordMethod = m.type === 'discord';
                const finalTotal = isDiscordMethod ? Math.round(onlineTotal * 1.05) : onlineTotal;
                
                const totalBonus = finalTotal - pack.amount;

                return (
                  <button 
                    key={i} 
                    onClick={() => handleBuyClick(m.type, m.url)}
                    className={`pack-pay-row${totalBonus > 0 ? ' has-bonus' : ''}`}
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', width: '100%' }}
                  >
                    <span className="pack-pay-icon">{m.icon}</span>
                    <span className="pack-pay-name">{m.name}</span>
                    {totalBonus > 0 ? (
                      <span className="pack-pay-bonus">+{totalBonus.toLocaleString('fr-FR')}</span>
                    ) : (
                      <span className="pack-pay-bonus no-bonus">—</span>
                    )}
                    <span className={`pack-pay-link ${m.type}`} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {m.type === 'discord' ? (
                        <><DiscordSVG /> {m.label}</>
                      ) : (
                        <><OnlinePaySVG /> {m.label}</>
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="shop-info">
        <h2 className="shop-info-title">Comment payer ?</h2>

        <div className="shop-info-cards">
          <div className="shop-info-card discord">
            <div className="shop-info-card-icon"><DiscordSVG /></div>
            <h3>Paiement via Discord</h3>
            <ol>
              <li>Rejoignez notre <a href="https://discord.gg/dTuaMqvSAr" target="_blank" rel="noopener noreferrer">serveur Discord</a></li>
              <li>Rendez-vous dans le salon <strong>#panel-joueur</strong></li>
              <li>Cliquez sur le bouton <span className="shop-info-btn">Paiement</span></li>
              <li>Écrivez votre demande (pack souhaité, pseudo en jeu) et un membre de l'équipe vous répondra rapidement</li>
            </ol>
            <p className="shop-info-note">Les paiements via <strong>Discord (PayPal ami, Paysafecard, Carte cadeau)</strong> bénéficient d'un <strong>bonus additionnel de +5 % d'Ogrines</strong> par rapport aux tarifs en ligne !</p>
          </div>

          <div className="shop-info-card guide">
            <div className="shop-info-card-icon">💳</div>
            <h3>Guide Paysafecard &amp; Carte cadeau</h3>
            <h4>Qu'est-ce qu'une Paysafecard ?</h4>
            <p>C'est un moyen de paiement prépayé disponible sous forme de carte avec un code à 16 chiffres. <strong>Aucun compte bancaire n'est nécessaire.</strong></p>
            <h4>Où acheter une Paysafecard ?</h4>
            <ul>
              <li><strong>Uniquement en bureau de tabac</strong>, supérette ou point de vente physique partenaire</li>
              <li>Montants disponibles : 10 €, 25 €, 50 €, 100 €</li>
            </ul>
            <p className="shop-info-warning">⚠️ Les <strong>Paysafecard achetées sur internet ne sont pas acceptées</strong> sur notre boutique. Seules les Paysafecard achetées en <strong>bureau de tabac</strong> (code physique) fonctionnent. Pour un paiement en ligne, passez plutôt par <strong>carte cadeau</strong>.</p>
            <h4>Comment nous l'envoyer ?</h4>
            <ol>
              <li>Ouvrez un ticket via <strong>#panel-joueur</strong> → bouton <span className="shop-info-btn">Paiement</span></li>
              <li>Indiquez le pack souhaité + votre pseudo en jeu</li>
              <li>Envoyez le <strong>code à 16 chiffres</strong> de votre Paysafecard dans le ticket</li>
              <li>Vos Ogrines seront crédités dès vérification !</li>
            </ol>
            <h4>Carte cadeau (Amazon, Steam, etc.)</h4>
            <p>Même procédure : ouvrez un ticket sur Discord, précisez le type de carte et envoyez le code ou une photo lisible du code.</p>
            <p className="shop-info-note">⚠️ Ne partagez <strong>jamais</strong> votre code en dehors du ticket privé avec l'équipe.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shop;